import { SIZE_GAP } from '../accessories.service';

export const defaultMoveMethod = {
  moveUpCondition: item => {
    const { altitude } = item;
    return altitude + SIZE_GAP <= item.position[1];
  },
  moveDownCondition: item => {
    const { altitude } = item;
    return altitude - SIZE_GAP >= item.position[0];
  },
  moveUp(item, accessories, index) {
    const { altitude, actualHeight } = item;
    if (this.moveUpCondition(item)) {
      accessories[index] = {
        ...item,
        altitude: altitude + SIZE_GAP,
        actualHeight: actualHeight + SIZE_GAP,
      };
    }
  },
  moveDown(item, accessories, index) {
    const { altitude, actualHeight } = item;

    if (this.moveDownCondition(item)) {
      accessories[index] = {
        ...item,
        altitude: altitude - SIZE_GAP,
        actualHeight: actualHeight - SIZE_GAP,
      };
    }
  },
  switchAltitude: (prevAltitude, item, index) => {
    const { position } = item;
    const [min] = position;
    return index === 0 && prevAltitude < min ? min : prevAltitude;
  },
};
